import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { E404Component } from './e404/e404.component';
import { LoaderComponent } from './loader/loader.component';
import { ProfileComponent } from './profile/profile.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridComponent } from './grid/grid.component';
import { BookCardComponent } from './book-card/book-card.component';
import { ChapterCardComponent } from './chapter-card/chapter-card.component';
import { PageCardComponent } from './page-card/page-card.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule, MatDialogContent } from '@angular/material/dialog';
import { CoreRoutingModule } from './core-routing.module';
import { ChapterFormComponentCore } from './chapter-form/chapter-form.component';
import { PageReaderCoreComponent } from './page-reader-core/page-reader-core.component';
import { MediaPlayerComponent } from './media-player/media-player.component';
import { NavigationGridComponent } from './navigation-grid/navigation-grid.component';
import { TransformUrlPipe } from '../../_helpers/common.functions';
import { SubscriptionComponent } from './subscription/subscription.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { OrderComponent } from './order/order.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { OrderPaymentComponent } from './order-payment/order-payment.component';
import { SubscriptionPlanCardComponent } from './subscription-plan-card/subscription-plan-card.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { TranslateModule } from '@ngx-translate/core';
import { UnsavedChangesDialogComponent } from './unsaved-changes-dialog/unsaved-changes-dialog.component';
import { ChangePageTypeDialogComponent } from './page-card/change-page-type-dialog/change-page-type-dialog.component';

@NgModule({
  declarations: [
    E404Component,
    AccessDeniedComponent,
    LoaderComponent,
    ProfileComponent,
    GridComponent,
    BookCardComponent,
    ChapterCardComponent,
    PageCardComponent,
    ChapterFormComponentCore,
    PageReaderCoreComponent,
    MediaPlayerComponent,
    NavigationGridComponent,
    SubscriptionComponent,
    OrderComponent,
    OrderPaymentComponent,
    SubscriptionPlanCardComponent,
    UnsavedChangesDialogComponent,
    ChangePageTypeDialogComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    CoreRoutingModule,
    MatMenuModule,
    MatButtonToggleModule,
    MatChipsModule,
    ReactiveFormsModule,
    MatDialogContent,
    MatDialogModule,
    FormsModule,
    CoreRoutingModule,
    TransformUrlPipe,
    MatTabsModule,
    MatTableModule,
    MatCardModule,
    MatSelectModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    TranslateModule,
  ],
  exports: [
    LoaderComponent,
    GridComponent,
    BookCardComponent,
    ChapterCardComponent,
    PageCardComponent,
    PageReaderCoreComponent,
    MediaPlayerComponent,
    MatDialogModule,
    NavigationGridComponent,
  ],
})
export class CoreModule {}
